module.exports = __webpack_public_path__ + "c514f1af9d3a74e0b3c18722a2b94413.png";